import { render, staticRenderFns } from "./options.vue?vue&type=template&id=f95e4766&scoped=true&"
import script from "./options.vue?vue&type=script&lang=js&"
export * from "./options.vue?vue&type=script&lang=js&"
import style0 from "./options.vue?vue&type=style&index=0&id=f95e4766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95e4766",
  null
  
)

export default component.exports